// extracted by mini-css-extract-plugin
export default {"Title":"styles_Title__Um1hN","Subtitle":"styles_Subtitle__vkYtt","container":"styles_container__j4FPe","info":"styles_info__zince","containerMobile":"styles_containerMobile__+AStJ"};